import qs from 'qs'
// import request from '@/utils/request'
import {api,apitest} from '../api.request';
// request.defaults.baseURL = "https://yapi.chujiangnet.com/mock/25/";


//本月店铺明星产品top20
function starProductsOfThisMonth(data) {
    // return request({
    //   url: '/bottom/storeNewMembers',
    //   method: 'get',
    //   data: qs.stringify({})
    // })
    return apitest.get("/bigStoreOperation/starProductsOfThisMonth",data)
  }
  //店铺客流与销售额
  function storePassengerFlowAndSales(data) {
    return apitest.get("/bigStoreOperation/storePassengerFlowAndSales",data)
  }
  //近30日销售趋势
  function salesTrend(data) {
    return apitest.get("/bigStoreOperation/salesTrend",data)
  }
   //中间统计数据
   function commodityDetails(date) {
    return apitest.get("/bigStoreOperation/commodityDetails",date)
  }
   //滚动文字
   function bigOrderNotification(date) {
    return apitest.get("/bigStoreOperation/bigOrderNotification",date)
  }
  //店铺实时客流
  function get5() {
    return api.get("/bigop/get5")
  }
  //本月店铺热力分析（图片）
  function get6() {
    return api.get("/bigop/get6")
  }
    //本月店铺热力分析（图表）
    function get7() {
      return api.get("/bigop/get7")
    }
     //下拉框门店列表
     function bigStore() {
      return apitest.get("/bigStoreOperation/bigStore")
    }





export default {
  starProductsOfThisMonth,
  storePassengerFlowAndSales,
  salesTrend,
  commodityDetails,
  bigOrderNotification,
    get5,
    get6,
    get7,
    bigStore
  }